// 9-pt sub-nav for ai.zafrm.pro (alias aiteam.zafrm.pro) per handoff §2.2.
//
// Order matters: handoff explicitly lists this set in this order.
// "Скилы" (not "Общие скилы") per concept audit DECISION — `common/roles/project`
// live as tabs inside the /skills screen (sprint 0.3 / roadmap «Концептуальные ограничения»).
//
// Шаг 2: nav driven by URL (react-router). Список 13 маршрутов из handoff
// `01-подход-и-каркас.md §3` живёт в `app/routes.tsx`; здесь — только nav-points
// верхнего уровня с `href` для топбара и helper для активного пункта по pathname.

import type { ProductTopBarNavItem } from '@frm/ui'

export interface AgentsNavItem extends ProductTopBarNavItem {
  id: NavId
  href: string
}

export type NavId =
  | 'agents'
  | 'skills'
  | 'projects'
  | 'sessions'
  | 'releases'
  | 'chat'
  | 'vaults'
  | 'help'

export const NAV_ITEMS: AgentsNavItem[] = [
  { id: 'agents', label: 'Агенты', href: '/' },
  { id: 'skills', label: 'Скилы', href: '/skills' },
  { id: 'projects', label: 'Проекты', href: '/projects' },
  { id: 'sessions', label: 'Сессии', href: '/sessions' },
  { id: 'releases', label: 'Релизы', href: '/releases' },
  // Web-chat отключён (owner-решение 2026-07-06: не используется). Возврат —
  // вернуть строку ниже. Backend /api/chat уже погашен в transport (404).
  // { id: 'chat', label: 'Чат', href: '/chat' },
  { id: 'vaults', label: 'Хранилища', href: '/vaults' },
  { id: 'help', label: 'Справка', href: '/help' },
]

export const DEFAULT_NAV: NavId = 'agents'

/**
 * Resolve active nav id from current pathname.
 *
 * Логика: `/` → agents, иначе ищем nav-item, у которого `href !== '/'` и
 * pathname с него начинается. Это даёт правильную подсветку для deep-link'ов
 * вроде `/agents/develop`, `/projects/frm.ai/ai.agents`, `/vaults/main/path/to/file`.
 */
export function resolveActiveNav(pathname: string): NavId {
  if (pathname === '/' || pathname === '') return 'agents'
  // Карточка агента — `/agents/:id`, не путать с `/` (Агенты — список).
  if (pathname.startsWith('/agents')) return 'agents'
  for (const item of NAV_ITEMS) {
    if (item.href === '/') continue
    if (pathname === item.href || pathname.startsWith(`${item.href}/`)) {
      return item.id
    }
  }
  return DEFAULT_NAV
}
